import { Dropdown, Option, OptionOnSelectData, SelectionEvents } from "@fluentui/react-components";
import { FunctionComponent } from "react";

export const LegislationDropdown: FunctionComponent<{ country: string, onCountrySelected: (ev: SelectionEvents, data: OptionOnSelectData) => void }> = ({ country, onCountrySelected }) => {

    return (<><div className="legislation">Legislation: &nbsp;</div>
        <Dropdown size='small' defaultValue={country} className="dropdown-legislation" onOptionSelect={onCountrySelected}>
            <Option text='England' value='England' >
                <span className="dropdown-item">England</span>
            </Option>
            <Option text='Ireland' value='Ireland' >
                <span className="dropdown-item">Ireland</span>
            </Option>            
        </Dropdown>
        </>
    )
}